import { MutationTree } from "vuex";
import { State } from "./Type";

const mutations: MutationTree<State> = {
  setLoading: (state, payload): void => {
    state.loading = payload;
  },
};

export default mutations;
